import { render, staticRenderFns } from "./NavApplicationMenuItemGroup.vue?vue&type=template&id=1f66e3f8"
import script from "./NavApplicationMenuItemGroup.vue?vue&type=script&lang=ts"
export * from "./NavApplicationMenuItemGroup.vue?vue&type=script&lang=ts"
import style0 from "./NavApplicationMenuItemGroup.vue?vue&type=style&index=0&id=1f66e3f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports